import { Component, OnInit } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { ListItem, MaterialLocationQuantity, RepositoryModal, Services } from '../../shared'
import { SmallToolLocationsComponent } from './small-tool-locations.component'
import { FormsModule } from '@angular/forms'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'

@Component({
    templateUrl: './small-tool-location.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class SmallToolLocationComponent extends RepositoryModal<MaterialLocationQuantity> implements OnInit {
    materialOptions: ListItem<string>[] = []
    locationOptions: ListItem<string>[] = []

    constructor() {
        super()
    }
    ngOnInit() {}

    protected onInitialized() {
        let parentController = this.editOptions.initializeParams as SmallToolLocationsComponent
        this.materialOptions = parentController.rawMaterials.map(x => new ListItem(x.barcode, x.name))
        this.locationOptions = parentController.rawLocations.map(x => new ListItem(x.key, x.value))
    }

    onBeforeSave() {
        if (!this.target.material || !this.target.location) {
            this.services.notification.warning('Please fill in all fields.')
            return false
        }
        return true
    }
}
